import { isAbUseExperimentActive } from './isAbUseExperimentActive';
import { DAILYRENT_MULTIPINS_EXP } from '../../constants/config';
import { TExperimentsState } from '../../types/experiments';

export function isMultipinsExpActive(experiments: TExperimentsState): boolean {
  return isAbUseExperimentActive(experiments, DAILYRENT_MULTIPINS_EXP, 'B');
}
